import React from 'react';

function ConsultModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black/50 z-[1000] flex items-center justify-center animate-[fadeIn_0.3s_ease]"
      onClick={onClose}
    >
      <div
        className="bg-white p-10 rounded-2xl max-w-[500px] w-[90%] text-center relative shadow-[0_20px_40px_rgba(0,0,0,0.2)] animate-[scaleIn_0.3s_cubic-bezier(0.175,0.885,0.32,1.275)]"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="absolute top-5 right-5 text-2xl text-gray-400 hover:text-primary transition-colors bg-transparent border-none cursor-pointer p-1"
          onClick={onClose}
        >
          &#10006;
        </button>
        <div className="text-5xl mb-4">&#128140;</div>
        <h3 className="text-3xl font-bold text-[#2c3e50] mb-4">창업 상담 신청</h3>
        <p className="text-lg text-gray-600 mb-8 leading-relaxed">
          플라워 플랫폼 쇼핑몰 개설은 관리자 상담 후 진행됩니다.<br/>
          아래 연락처로 문의 주시면 친절히 안내해 드리겠습니다.
        </p>

        <div className="bg-[#f8f9fa] p-5 rounded-xl mb-8">
          <div className="flex justify-center items-center gap-2 mb-2 text-[#333] font-medium last:mb-0">
            <span>&#128222;</span>
            <span>010-3782-8997</span>
          </div>
          <div className="flex justify-center items-center gap-2 mb-2 text-[#333] font-medium last:mb-0">
            <span>&#128231;</span>
            <span>flowerplatform26@gmail.com</span>
          </div>
          <div className="flex justify-center items-center gap-2 mb-2 text-[#333] font-medium last:mb-0">
            <span>&#128172;</span>
            <span>카카오톡: @flowerplatform</span>
          </div>
        </div>

        <button
          className="px-8 py-3 bg-primary text-primary-contrast rounded-full font-bold text-lg hover:bg-primary-hover transition-colors border-none cursor-pointer"
          onClick={onClose}
        >
          확인했습니다
        </button>
      </div>
    </div>
  );
}

export default ConsultModal;
